const ORDER_PLACED = "注文済";
const ORDER_CONFIRMED = "発注済";
const ORDER_RECEIVED = "検収済";
const ORDER_CANCELLED = "取消済";
const SELECTED_ORDER_PLACED = "注文";
const SELECTED_ORDER_CONFIRMED = "発注";
const SELECTED_ORDER_RECEIVED = "検収";
const SELECTED_ORDER_CANCELLED = "取消";
// 旧フィルタ用の orderStatusList / ORDER_STATUS_ALL("すべて")は廃止。
// 検索フィルタの選択肢は functions/order/orderSearchModel.js の STATUS_OPTIONS が持つ
// (「すべて」は選択肢ではなく全選択として表現する)。

export {
  ORDER_PLACED,
  ORDER_CONFIRMED,
  ORDER_RECEIVED,
  ORDER_CANCELLED,
  SELECTED_ORDER_PLACED,
  SELECTED_ORDER_CONFIRMED,
  SELECTED_ORDER_RECEIVED,
  SELECTED_ORDER_CANCELLED,
};
